export default {"src":"/_next/static/media/AVTR.362e7122.svg","height":18,"width":18};